// extracted by mini-css-extract-plugin
export default {"error-message-box":"DropDownInput_error-message-box__X-RIF"};